import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { TeamDto } from '@/infra/api/generated/model'

type TeamProfileProps = {
  team?: TeamDto
}

const TeamPreference = ({ team }: TeamProfileProps) => {
  const { t } = useTranslation('common')
  return (
    <Link
      to="/select-team"
      viewTransition
      className="flex justify-between items-center py-3 hover:bg-gray-50 rounded-md px-2 -mx-2"
    >
      <div>
        <p className="font-medium">{t('components.preferences.team')}</p>
        {team && <p className="text-sm text-gray-500">{team.name}</p>}
      </div>
      <img alt="right chevron icon" src="/icons/chevron.svg" width={24} height={24} />
    </Link>
  )
}

export default TeamPreference
